import React from "react";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import InstagramIcon from "@mui/icons-material/Instagram";

const Footer = () => {
  return (
    <footer className="flex flex-col p-0 m-0">
      <div className="bg-secondary text-primary-content md:py-20 md:px-48 px-4 py-4 flex flex-col-reverse gap-6">
        <div className="flex  flex-row justify-between items-center w-full">
          <div className="flex md:flex-row flex-col gap-4 text-black text-center">
            <a href={"s"} target="_blank" rel="noreferrer">
              À propos de nous
            </a>
            <a href={"/blog"}>Articles</a>
          </div>
          <div className="flex md:flex-row flex-col gap-4 text-black text-center">
            <a href="/CGU.pdf" download="Conditions_Generales.pdf">
              Conditions Générales
            </a>
            <a href="/CGU.pdf" download="Conditions_Generales.pdf">
              Politique de confidentialité
            </a>
          </div>
        </div>

        <div className="divider divider-vertical w-full h-0.5 bg-primary" />

        <div className="flex flex-col-reverse md:flex-row  justify-between items-center w-full gap-[30px]">
          <div>
            <div>&copy; 2023 Studycool. Tous droits réservés.</div>
          </div>
          <div className="flex justify-center items-center md:mr-40">
            <div className="flex-auto my-auto text-3xl font-extrabold text-primary">
              <span className="text-black">Study</span>cool
            </div>
          </div>

          <div className="flex md:gap-6 gap-3">
            <a
              href={"https://www.linkedin.com/company/studycoool"}
              passHref
              target="_blank"
              rel="noreferrer"
            >
              <LinkedInIcon />
            </a>
            <a href={"mailto:studycool.contact@gmail.com"} passHref>
              <EmailIcon />
            </a>
            <a
              href={"https://www.instagram.com/_studycool/"}
              passHref
              target="_blank"
              rel="noreferrer"
            >
              <InstagramIcon />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
